/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecaptchaBaseConfig } from '../../models/recaptcha-base-config';

export interface ConfigurationCaptchaGet$Params {}

export function configurationCaptchaGet(
  http: HttpClient,
  rootUrl: string,
  params?: ConfigurationCaptchaGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RecaptchaBaseConfig>> {
  const rb = new RequestBuilder(rootUrl, configurationCaptchaGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecaptchaBaseConfig>;
    }),
  );
}

configurationCaptchaGet.PATH = '/Configuration/captcha';
